import { React, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Menu,
  MenuItem,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import UserProfileModal from "../../pages/auth/UserProfile";

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useSelector } from "react-redux";
function Header({ profileModal, setProfileModal }) {
  useEffect(() => window.scrollTo(0, 0));
  const userData = useSelector((state) => state?.userReducer?.userData);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate=useNavigate()
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    // navigate('/profile')
  };

  const handleMenuClose = () => {
    setAnchorEl(null)
    setProfileModal(null);
  };
  return (
    <Box className="d-flex align-items-center justify-content-between" py={2} >
      <Box className="d-flex align-items-center header-avatar" >
      <Typography color="primary" component="h6" >{userData?.username}</Typography>
        <IconButton onClick={handleMenuOpen} color="inherit" fontSize="large"  >
          <AccountCircleIcon className="avatar" />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem onClick={handleMenuClose} component={Link} to="/profile"  >
            <AccountCircleIcon className="mr-3" color="primary" /> Profile
          </MenuItem>
          <MenuItem onClick={(handleMenuClose)} component={Link} to="/change-password" >
            <AccountCircleIcon className="mr-3" color="primary" /> Change Password
          </MenuItem>
        </Menu>
      </Box>
      <UserProfileModal {...{ profileModal, setProfileModal }} />
    </Box>
  );
}

export default Header;
